// extracted by mini-css-extract-plugin
export var compactFilters = "_ht-4";
export var detailImage = "_ht-1";
export var dropdownContainer = "_ht-2";
export var imageContainer = "_ht-0";
export var selectedCard = "_ht-3";